/**
 * Return true if there are any quotes loading
 * @param state
 * @returns {boolean}
 */
export function hasQuoteLoading(state) {
  return Object.values(state.quotesLoading).includes(true);
}
